
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import {CashoutClientMoney} from "../../../../dev/actions/terminal";
import { UIMixin } from "../../../mixins/uiMixin";
import PropTypes from "prop-types";
import { createSelector } from "reselect";

class DmsLoggedInCashout extends Component {
    constructor (props) {
        super(props);
        this.cashOut = this.cashOut.bind(this);
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
    cashOut () {
        return () => {
            this.props.closePopup()();
            this.props.dispatch(CashoutClientMoney(null));
        };
    }
}

const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.terminal.isAdminLoggedIn
        ],
        (isAdminLoggedIn) => {
            return {isAdminLoggedIn};
        }
    );
};

DmsLoggedInCashout.propTypes = {
    closePopup: PropTypes.func
};

export default connect(mapStateToProps)(UIMixin({Component: DmsLoggedInCashout}));